import React from 'react'
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import gsap from 'gsap'
import { useGSAP } from '@gsap/react'

import './styles/text-bubble.css'
import classNames from './utils'


const TextBubble = ({ text = 'Hey!' }) => {

  const navigate = useNavigate()

  gsap.registerPlugin(useGSAP)

  const isMobile = window.innerWidth <= 768
  const isTablet = window.innerWidth > 768 && window.innerWidth <= 1440

  const [loading, setLoading] = useState(true)

  const chatRef = useRef(null)

  useGSAP(() => {
    if ( isMobile ) {
      gsap.fromTo(chatRef.current,
        { y: '0', opacity: 0, scale: 0.5 }, {
          x: '+225', y: 0, opacity: 1,
          duration: 0.25,
          delay: 1,
          ease: 'easeIn',
        })
    } else if ( isTablet ) {
      gsap.fromTo(chatRef.current,
        { x: '+50', opacity: 0, scale: 1}, {
          x: 0, opacity: 1,
          duration: 0.25,
          delay: 1,
          ease: 'easeIn',
        })
    } else {
      gsap.fromTo(chatRef.current,
        { y: '+50', opacity: 0 }, {
          y: 0, opacity: 1,
          duration: 0.25,
          delay: 1,
          scale: 1,
          ease: 'easeIn',
        })
    }

    gsap.fromTo('.text-bubble-circle',
      { y: '-25', opacity: 0.75 }, {
      y: 0,
      opacity: 1,
      duration: 0.5,
      delay: 0,
      stagger: 0.15,
      repeat: -1,
      yoyo: 1,
      ease: 'power1.inOut'
    })

    const timeout = Math.round(Math.random() * 3) * 1000 + 1500 // ms
    const timeoutID = setTimeout(() => {
      clearTimeout(timeoutID)
      setLoading(false)
    }, timeout)
  })

  return (
    <svg className="text-bubble" viewBox="0 0 1750 800"
      onClick={() => navigate('/chat')}>
      <defs>
        <linearGradient id="text-bubble-gradient" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FF4500" />
          <stop offset="50%" stopColor="#9E0086" />
          <stop offset="100%" stopColor="#130065" />
        </linearGradient>
      </defs>
      <g ref={chatRef} fill="none" fillRule="evenodd">
        <path fill="#111" d="M350 0h1050c193.3 0 350 156.7 350 350v450H350C156.7 800 0 643.3 0 450V350C0 156.7 156.7 0 350 0Z"/>
        <path id="text-bubble-bg" fill="url(#text-bubble-gradient)" d="M350 0h1050c193.3 0 350 156.7 350 350v450H350C156.7 800 0 643.3 0 450V350C0 156.7 156.7 0 350 0Z" />
        <circle cx="525" cy="400" r="125" fill="#FFF"
          className={classNames('text-bubble-circle', { loading })} />
        <circle cx="875" cy="400" r="125" fill="#FFF"
          className={classNames('text-bubble-circle', { loading })} />
        <circle cx="1225" cy="400" r="125" fill="#FFF"
          className={classNames('text-bubble-circle', { loading })} />
        <text fill="#FFF" fontFamily="HelveticaNeue-Bold, Helvetica Neue" fontSize="500" fontWeight="bold">
          <tspan x="300" y="592">{ loading ? '' : text}</tspan>
        </text>
      </g>
    </svg>
  )
}


export default TextBubble
